if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-icon__card',
          fallbackContainerA: '.slideshow__item-wrap',
          fallbackContainerB: '.hotspot-layer'
        };

        this._onMouseOver = this.init.bind(this);

        this.init();
        document.addEventListener('matchMobile', this.init.bind(this));
        document.addEventListener('unmatchMobile', this.init.bind(this));
        this.addEventListener('mouseover', this._onMouseOver);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this._onMouseOver);
      }

      _resolveWrapper() {
        let wrapper = this.closest(this.selectors.cardContainer);
        if (wrapper) return wrapper;

        wrapper =
          this.closest(this.selectors.fallbackContainerA) ||
          this.closest(this.selectors.fallbackContainerB) ||
          this.offsetParent ||
          this.parentElement;
        return wrapper || null;
      }

      init() {
        const card = this.querySelector(this.selectors.cardProduct);
        const wrapper = this._resolveWrapper();
        if (!card || !wrapper) return;

        const wrapperRect = wrapper.getBoundingClientRect();
        const selfRect = this.getBoundingClientRect();

        const offsetX = selfRect.left - wrapperRect.left;
        const offsetY = selfRect.top - wrapperRect.top;

        const selfW = this.clientWidth || selfRect.width || 0;
        const cardRect = card.getBoundingClientRect();
        const cardW = card.clientWidth || cardRect.width || 0;
        const cardH = card.clientHeight || cardRect.height || 0;
        const wrapperW = wrapper.clientWidth || wrapperRect.width || 0;

        let pos = offsetY > cardH ? 'top' : 'bottom';
        if (offsetX + selfW > cardW) {
          pos += '-left';
        } else if (wrapperW - offsetX > cardW) {
          pos += '-right';
        }
        this.dataset.position = pos;

        // 🔹 Toggle behaviour (mobile only)
        if (!this._eventsBound) {
          this._eventsBound = true;

          const pin = this.querySelector('.lookbook-icon__pin');
          if (pin) {
            pin.addEventListener('click', (e) => {
              if (window.matchMedia('(max-width: 767px)').matches) {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = this.classList.contains('is-active');

                // Close all others
                document.querySelectorAll('lookbook-icon.is-active').forEach((el) => {
                  el.classList.remove('is-active');
                  // Reset their icon to plus
                  const vpath = el.querySelector('.lookbook-icon__pin path.vertical');
                  if (vpath) vpath.style.transform = 'rotate(0deg)';
                });

                if (!isOpen) {
                  // Open this one
                  this.classList.add('is-active');
                  const vpath = this.querySelector('.lookbook-icon__pin path.vertical');
                  if (vpath) vpath.style.transform = 'rotate(90deg)';
                } else {
                  // Explicitly close + reset icon
                  this.classList.remove('is-active');
                  const vpath = this.querySelector('.lookbook-icon__pin path.vertical');
                  if (vpath) vpath.style.transform = 'rotate(0deg)';
                }
              }
            });
          }
        }

        // Shopify editor mode
        if (window.Shopify && Shopify.designMode && card) {
          this.removeEventListener('shopify:block:select', this._onBlockSelect);
          this.removeEventListener('shopify:block:deselect', this._onBlockDeselect);

          this._onBlockSelect = () => {
            card.style.transition = 'none';
            this.classList.add('is-active');
          };
          this._onBlockDeselect = () => {
            this.classList.remove('is-active');
          };

          this.addEventListener('shopify:block:select', this._onBlockSelect);
          this.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }
    }
  );
}
